<template>
  <div class="funnel-form">
    <voyage-card :voyage="voyage"></voyage-card>

    <div v-if="!sansTransport" class="bloc-form">
      <h3 class="titre d-flex">
        <i class="fal text-primary fa-plane-departure fa-fw"></i>
        <label for="depart" class="pl-3"
          >D'où souhaitez-vous partir&nbsp;?</label
        >
      </h3>

      <div class="form-group form-filtre form-filtre-sm">
        <v-select
          id="depart"
          :options="aeroports"
          :removable="false"
          label-title="Sélectionner"
          v-model="selectedAeroport"
        />
      </div>
    </div>

    <div v-if="voyage.template == 3" class="bloc-form">
      <h3 class="titre d-flex">
        <i class="fal text-primary fa-moon fa-fw"></i>
        <label for="duree" class="pl-3">Pendant combien de temps&nbsp;?</label>
      </h3>

      <div class="form-group form-filtre form-filtre-sm">
        <v-select
          id="duree"
          :options="durees"
          :removable="false"
          label-title="Sélectionner"
          v-model="selectedDuree"
        />
      </div>
    </div>

    <div class="bloc-form">
      <h3 class="titre d-flex">
        <i class="fal text-primary fa-users fa-fw"></i>
        <span class="pl-3">Combien serez-vous à partir&nbsp;?</span>
      </h3>

      <div class="form-group form-filtre">
        <!--<label for="nombreChambres"
          ><i class="fal text-primary fa-bed-empty mr-2 picto-small"></i
          >Chambres <span class="infos">(4 max.)</span></label
        >
        <b-form-spinbutton
          min="1"
          max="4"
          v-model="nombreChambres"
          name="nombreChambres"
        ></b-form-spinbutton>-->

        <div
          v-for="(chambre, index) in chambres"
          :key="'chambre-' + index"
          class="row row-chambre"
        >
          <div class="col-12 col-md-3">
            <h6>Chambre {{ index + 1 }}</h6>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-6">
                <label :for="'adultes-' + index">
                  <div class="media align-items-center">
                    <i class="fal text-primary fa-users fa-fw mr-2"></i>
                    <div class="media-body adultes-enfants">
                      Adultes<br />
                      <span class="infos">(4 pers. max.)</span>
                    </div>
                  </div>
                </label>
                <b-form-spinbutton
                  min="0"
                  max="4"
                  v-model="chambre.adulte"
                  :name="'adultes-' + index"
                  @change="updateAdulte(index, $event)"
                ></b-form-spinbutton>
              </div>

              <div class="col-6">
                <label :for="'enfants-' + index">
                  <div class="media align-items-center">
                    <i class="fal text-primary fa-child fa-fw mr-2"></i>
                    <div class="media-body adultes-enfants">
                      Enfants &le; 12 ans<br />
                      <span class="infos">(3 pers. max.)</span>
                    </div>
                  </div>
                </label>
                <b-form-spinbutton
                  min="0"
                  max="3"
                  :value="0"
                  :name="'enfants-' + index"
                  @change="updateNombreEnfant(index, $event)"
                ></b-form-spinbutton>
              </div>

              <div
                class="col-4 mt-3"
                v-for="indexEnfant in getNombreEnfantsChambre(index)"
                :key="'enfant-' + index + '-' + indexEnfant"
              >
                <label :for="'enfants-' + index + '-' + indexEnfant">
                  <div class="media align-items-center">
                    <div class="media-body adultes-enfants">
                      Âge de l'enfant {{ indexEnfant }}<br />
                    </div>
                  </div>
                </label>
                <b-form-spinbutton
                  min="0"
                  max="12"
                  :value="getAgeEnfantChambre(index, indexEnfant)"
                  :name="'enfants-' + index + '-' + indexEnfant"
                  @change="updateAgeEnfantChambre(index, indexEnfant, $event)"
                ></b-form-spinbutton>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <button
            class="btn btn-dark btn-sm mr-2"
            type="button"
            v-if="$store.getters.nombreChambres > 1"
            @click="removeRoom"
          >
            Retirer une chambre
          </button>
          <button
            class="btn btn-secondary btn-sm"
            type="button"
            v-if="$store.getters.nombreChambres < 4"
            @click="addRoom"
          >
            Ajouter une chambre
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VoyageCard from "./VoyageCard";
import VSelect from "../../../recherche/src/components/VueBootstrapSelect";
import Vue from "vue";
import { FormSpinbuttonPlugin } from "bootstrap-vue";
Vue.use(FormSpinbuttonPlugin);

export default {
  name: "FunnelForm",

  components: {
    VoyageCard,
    VSelect
  },

  computed: {
    voyage() {
      return this.$store.state.voyage;
    },

    durees() {
      return this.$store.getters.durees;
    },

    aeroports() {
      return this.$store.getters.aeroports;
    },

    pictos() {
      return this.$store.state.pictos;
    },

    selectedAeroport: {
      get() {
        return this.$store.state.selectedAeroport;
      },
      set(value) {
        this.$store.dispatch("updateAeroport", value);
      }
    },

    selectedDuree: {
      get() {
        return this.$store.state.selectedDuree;
      },
      set(value) {
        this.$store.dispatch("updateDuree", value);
      }
    },

    nombreChambres: {
      get() {
        return this.$store.getters.nombreChambres;
      },
      set(value) {
        this.$store.dispatch("updateChambres", value);
      }
    },

    chambres() {
      return this.$store.state.chambres;
    },


	sansTransport() {
		return this.$store.state.sansTransport
	}
  },

  methods: {
    updateAdulte(index, event) {
      this.$store.dispatch("updateAdulte", { index: index, value: event });
    },
    updateNombreEnfant(index, event) {
      this.$store.dispatch("updateNombreEnfant", {
        index: index,
        value: event
      });
    },
    updateAgeEnfantChambre(numeroChambre, indexEnfant, event) {
      this.$store.dispatch("updateAgeEnfantChambre", {
        numeroChambre: numeroChambre,
        indexEnfant: indexEnfant - 1,
        value: event
      });
    },
    getNombreEnfantsChambre(numeroChambre) {
      return this.$store.state.chambres[numeroChambre].enfant.length;
    },
    getAgeEnfantChambre(numeroChambre, indexEnfant) {
      return this.$store.state.chambres[numeroChambre].enfant[indexEnfant - 1];
    },
    addRoom() {
      this.$store.dispatch(
        "updateChambres",
        this.$store.getters.nombreChambres + 1
      );
    },
    removeRoom() {
      this.$store.dispatch(
        "updateChambres",
        this.$store.getters.nombreChambres - 1
      );
    }
  }
};
</script>
